
export class ApprovedTransactionFilter {
    startDate: Date;
    endDate: Date;
}
export class TransactionByReasonFilter {
    start: Date;
    end: Date;
    establishmentId: number;
}